import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class MultiDepositLimitConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	/**
	 * This config is under jurisdiction
	 */
	getMultiDepositLimitEndpoint(): string {
		return this.configService.get(
			(x) => x.core.multiDepositLimit.endpoints?.multiDepositLimit,
			"v1/currentcustomerlimits/depositlimit"
		);
	}

	/**
	 * This config is under jurisdiction
	 */
	getMultiDepositLimitEnabled(): boolean {
		return this.configService.get((x) => x.core.multiDepositLimit.isMultiDepositLimitEnabled, false);
	}
}
